import React, { useState, useEffect } from "react";
import { Typography, Row, Col, Divider, Tooltip, Button } from "antd";
import { capitalize } from "utils/randomString";

const { Text } = Typography;
export default function HSCodes({ data, hsCodes, userHsCode }) {
  const [HSCodes, setHSCodes] = useState([]);
  const [hsCodeData, setHsCodeData] = useState(null);
  const [allhscodes, setAllhscodes] = useState([]);

  useEffect(() => {
    if (hsCodeData && userHsCode?.length > 0 && hsCodeData?.hscodes?.length) {
      const sorter = (a, b) => {
        if (userHsCode.includes(`${a}`)) {
          return -1;
        }
        if (userHsCode.includes(`${b}`)) {
          return 1;
        }
        return 0;
      };

      setAllhscodes(hsCodeData?.hscodes.sort(sorter));
    }
  }, [hsCodeData, userHsCode]);
  useEffect(() => {
    if (allhscodes.length > 0) {
      setHSCodes(allhscodes?.slice(0, 5));
    }
  }, [allhscodes]);
  useEffect(() => {
    if (data?.hscodes) {
      setHsCodeData(data);
    }
  }, [data]);
  const handleViewMore = () => {
    setHSCodes(hsCodeData?.hscodes);
  };
  const handleViewLess = () => {
    setHSCodes(hsCodeData?.hscodes?.slice(0, 5));
  };
  return (
    <Row>
      <Col span={24}>
        <Text style={{ color: "#1D2624" }}>Relevant HS Codes</Text>
      </Col>
      <Col span={24}>
        {HSCodes.map((item, index) => (
          <>
            <Tooltip title={capitalize(hsCodes?.[item])}>
              <Text key={index} style={{ color: "#1D2624" }}>
                {item}
              </Text>
            </Tooltip>

            {index === HSCodes.length - 1 ? null : (
              <Divider type="vertical" style={{ borderColor: "#1D2624" }} />
            )}
          </>
        ))}

        {data?.hscodes?.length > 5 ? (
          HSCodes.length === 5 ? (
            <Button type="link" onClick={() => handleViewMore()}>
              View more
            </Button>
          ) : (
            <Button type="link" onClick={() => handleViewLess()}>
              View less
            </Button>
          )
        ) : null}
      </Col>
    </Row>
  );
}
